import React, { useEffect, useState, useCallback } from 'react'
import { Form } from '@unform/web'
import { Link } from 'react-router-dom'
import { loadRoles } from '../../../../actions/user'
import InputLabel from '../../../../components/Form/input/InputLabel'
import SelectLabel from '../../../../components/Form/input/SelectLabel'

function FormUser(props) {
  const [roles, setRoles] = useState([])

  const getRoles = useCallback(() => {
    loadRoles().then(data => {
      if (!props.formRef.current) return null
      const options = data.map(item => {
        return { label: item.description, value: item.id }
      })
      setRoles(options)
    })
  }, [props, setRoles])

  useEffect(() => {
    getRoles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form
      ref={props.formRef}
      initialData={props.initialData}
      onSubmit={props.submit}
      noValidate>
      <div className="row justify-content-center">
        <div className="col-sm col-md-6">
          <InputLabel name="name" label="Nome" />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-sm col-md-6">
          <InputLabel name="email" label="E-mail" />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-sm col-md-6 d-flex p-0">
          <div className="col">
            <InputLabel name="username" label="Usuário" />
          </div>

          {!props.initialData.id && (
            <div className="col">
              <SelectLabel
                name="role"
                label="Perfil"
                placeholder="Selecione.."
                options={roles}
              />
            </div>
          )}
        </div>
      </div>

      {!props.initialData.id && (
        <div className="row justify-content-center">
          <div className="col-sm col-md-6 d-flex p-0">
            <div className="col">
              <InputLabel type="password" name="password" label="Senha" />
            </div>
            <div className="col">
              <InputLabel type="password" name="confirm_password" label="Confirmar Senha" />
            </div>
          </div>
        </div>
      )}

      <div className="row justify-content-center mt-5">
        <div className="col-sm col-md-6 d-flex justify-content-end p-0">
          <div className="col">
            <Link to="/users" className="btn btn-lg  btn-block border-info">
              Voltar
            </Link>
          </div>
          <div className="col">
            <button type="submit" className="btn btn-lg btn-block btn-info">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </Form >
  )
}

FormUser.defaultProps = {
  submit: Function,
  formRef: Function,
  initialData: Object,
}

export default FormUser